import React from 'react'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import Tooltip from 'material-ui/Tooltip'
import { withStyles } from 'material-ui/styles'
import styles from '../styles'

class Toolbar extends React.Component {
  render () {
    const {
      classes,
      toggle,
      sendemailreport,
      showEmail,
      translate,
      toggleFilters,
      refresh,
      remove,
      signalRUpdate
    } = this.props

    return (
      <div>
        <Tooltip title={translate("tooltip_reload_reports")} disableTriggerFocus={true}>
          <Button
            className={classes.button}
            color='primary'
            fab
            mini
            onClick={() => refresh()}
          >
            <Icon>refresh</Icon>
          </Button>
        </Tooltip>
        <Tooltip title={translate("tooltip_filter")} disableTriggerFocus={true}>
          <Button
            className={classes.button}
            color='primary'
            fab
            mini
            onClick={() =>  toggleFilters()}
          >
            <Icon>filter_list</Icon>
          </Button>
          </Tooltip>
        {showEmail &&
          <Tooltip title={translate("send_report")} disableTriggerFocus={true}>
            <Button
              className={classes.button}
              color='primary'
              fab
              mini
              onClick={() => sendemailreport()}
            >
              <Icon>email</Icon>
            </Button>
          </Tooltip>}
      { showEmail &&  <Tooltip title={translate("delete_report")} disableTriggerFocus={true}>
          <Button
            className={classes.button}
            color='primary'
            fab
            mini
            onClick={() => remove()}
          >
            <Icon>delete</Icon>
          </Button>
        </Tooltip>
      }
        <Tooltip title={translate("tooltip_view_columns")} disableTriggerFocus={true}>
          <Button
            className={classes.button}
            color='accent'
            fab
            mini
            onClick={() => toggle()}
          >
            <Icon>view_column</Icon>
          </Button>
        </Tooltip>

        { signalRUpdate && <Tooltip title={translate("auto_refresh_enabled")} disableTriggerFocus={true}>
          <Button
            className={classes.button}
            color='accent'
            fab
            mini
            onClick={() => {}}
          >
            <Icon>sync</Icon>
          </Button>
        </Tooltip>
        }

      </div>
    )
  }
}

export default withStyles(styles)(Toolbar)
